import Shimmer from '../Shimmer';

const CreditCardLoadingState = (): JSX.Element => {
  return <Shimmer className="size-full min-h-36 lg:min-h-[10.5rem]" />;
};

export default CreditCardLoadingState;
